export const OAuthCallbackKey = 'OAuthCallback';
export const OAuthSamlCallbackKey = 'oauthSamlCallback';
export const allOAuthKeys = [OAuthCallbackKey, OAuthSamlCallbackKey];
